var map = {
	"./AAVE.svg": 1772,
	"./ADA.svg": 4642,
	"./ALGO.svg": 4688,
	"./APE.svg": 5703,
	"./ATOM.svg": 215,
	"./AVAX.svg": 2879,
	"./BNB.svg": 4006,
	"./BTC.svg": 3591,
	"./DOGE.svg": 3283,
	"./DOT.svg": 6818,
	"./ETH.svg": 6045,
	"./Group80.svg": 9584,
	"./Group83.svg": 1506,
	"./Group84.svg": 7998,
	"./Group85.svg": 8473,
	"./Group86.svg": 9018,
	"./Ikbal.svg": 5913,
	"./LINK.svg": 2214,
	"./LTC.svg": 7811,
	"./MATIC.svg": 4590,
	"./NEAR.svg": 5802,
	"./SOL.svg": 8670,
	"./TRX.svg": 7900,
	"./Vector.svg": 4726,
	"./Vector1.svg": 6156,
	"./XRP.svg": 8501,
	"./apollox.svg": 3917,
	"./arbitrum.svg": 8907,
	"./backgroung.svg": 6567,
	"./backgroung_phone.svg": 9429,
	"./binance.svg": 9811,
	"./lite.svg": 568,
	"./logo_dark.svg": 7328,
	"./logo_dark_foot.svg": 4845,
	"./meun.svg": 272,
	"./openc.svg": 8137,
	"./screenshoot.svg": 2257,
	"./tether.svg": 3313,
	"./twitter.svg": 6179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;